import React from "react";
import { CheckedLink } from "../../reusables";
import "./index.scss";

export default function SectionCardStraightStyled({ data }) {
	return (
		<ul className="section-cards--straight-styled">
			{data?.map(({ heading, description, linkTo }) => (
				<div key={heading} className="section-item">
					<li>
						{heading && description && (
							<div>
								<h4>{heading}</h4>

								<p className="small">{description}</p>

								<CheckedLink link={linkTo}>
									Learn more
								</CheckedLink>
							</div>
						)}
					</li>
				</div>
			))}
		</ul>
	);
}
